export default __webpack_public_path__ + "static/profilepic250-c3d2f06d353e300c5a2cb4e2f85ebc93.png";